// @ts-ignore
import { FeatureAppConfig } from '@ngw6fa/feature-app';
import { ModelOverviewIntegratorOptions } from '../create-options-from-query-params';

export function createFormsAppConfig({
  mocksBaseUrl,
  faServicesUrl,
}: ModelOverviewIntegratorOptions): FeatureAppConfig & any {
  return {
    mode: 'inline',
    mocksBaseUrl,
    hasContentConfig: true,
    // FORMS FEATURE APP
    formConfiguration: {
      formName: 'Contact Dealer From Integrator',
      title: '**Check your qualification INTEGRATOR**',
      description:
        'Contact your local dealer to see if you qualify for the Volkswagen Military & First Responder Bonus.INTEGRATOR',
      CTAlabel: 'Contact your local dealer INTEGRATOR',
      background: 'linear-gradient(to bottom, #00437a -50%, #001e50 50%)',
      legalDisclaimer:
        'By clicking "Submit request", you agree to Volkswagen’s [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html). In addition. by clicking "Submit request", you also agree and consent to receive marketing communications regarding Volkswagen products and services from Volkswagen by calling or texting you at the phone number(s) you’ve provided. You understand these calls or text may be made using an automatic telephone dialing system and/or prerecorded message. Your consent to receive calls or texts is not required as a condition of any purchase or lease.',
      submitCTA: 'Submit',
      requestType: 'leads',
      paramsType: 'queryParamsJson',
      formStructure:
        '"model" "firstName" "lastName" "email" "phone" "contactMethod" "zip" "comments"',
      structureColumns: 1,
      hideModelDropdown: true,
      implicitZipCode: false,
      hideBanner: false,
      featureAppSize: 'grid000',
      successMessageContent: {
        headerLabel: 'Thank you for contacting us from Integrator!',
        description:
          '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need. FROM INTEGRATOR</p>',
        buttonCtaLabel: 'Okay from Integrator',
      },
      failedMessageContent: {
        headerLabel: 'Ops Integrator!',
        description: '<p>Ops message from Integrator</p>',
        buttonCtaLabel: 'Back $$formName$$ from Integrator',
      },
    },
    fieldsConfiguration: {
      'brand': 'VW',
      'sourceType': 'vw',
      'subType': ' vw_special offers',
      'tag-BrightTagID': '',
      'tag-CampaignID': '',
      'tag-OmnitureID': '',
      'formType': 'lead',
      'formName': '',
      'requestType': '',
      'firstName': '',
      'lastName': '',
      'email': '',
      'phone': '',
      'preferredContactMethod': 'email',
      'comments': '',
    },
    faServicesUrl,
  };
}
